export const DEFAULT_BPM = 108;
export const TEMPO_MULTIPLIERS = ['×0.5', '×0.75', '×1', '×1.25'] as const;
